/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'extension.charts.aggregateData': '데이터 집계',
  'extension.charts.aggregateDataDescription': '여러 행에 같은 값이 있는 경우 값을 단일 데이터 포인트로 결합합니다.',
  'extension.charts.category': '범주',
  'extension.charts.customizeTab': '사용자 지정',
  'extension.charts.dataMissing.details': '페이지에서 이 차트의 소스 테이블을 찾을 수 없습니다.',
  'extension.charts.dataMissing.title': '표시할 데이터가 없음',
  'extension.charts.dataTab': '데이터',
  'extension.charts.defaultColumnName': '{0} 열',
  'extension.charts.defaultTitle': '제목 없는 차트',
  'extension.charts.defaultYLabel': '제목 없는 축',
  'extension.charts.extensionTitle': '차트',
  'extension.charts.height': '그림 영역 높이',
  'extension.charts.height.large': '더 높게',
  'extension.charts.height.medium': '기본값',
  'extension.charts.height.small': '더 짧게',
  'extension.charts.horizontal.orientation.label': '가로',
  'extension.charts.insert.tooltip': '차트 삽입',
  'extension.charts.legend': '범례',
  'extension.charts.legend.auto': '자동',
  'extension.charts.legend.bottom': '하단',
  'extension.charts.legend.left': '왼쪽',
  'extension.charts.legend.position': '범례 위치',
  'extension.charts.legend.right': '오른쪽',
  'extension.charts.legend.show': '범례 표시',
  'extension.charts.legend.top': '상단',
  'extension.charts.options.label': '차트 옵션',
  'extension.charts.options.tooltip': '차트 옵션 변경',
  'extension.charts.orientation.label': '방향',
  'extension.charts.seriesNames': '데이터 시리즈',
  'extension.charts.showPoints': '데이터 포인트 표시',
  'extension.charts.smoothLines': '부드러운 선',
  'extension.charts.style': '스타일',
  'extension.charts.title': '제목',
  'extension.charts.type.bar': '막대',
  'extension.charts.type.fieldDescription': '차트 유형',
  'extension.charts.type.line': '선',
  'extension.charts.type.pie': '파이',
  'extension.charts.userTitle': '제목',
  'extension.charts.vertical.orientation.label': '세로',
  'extension.charts.xAxis': 'X축',
  'extension.charts.xLabel': 'X축 레이블',
  'extension.charts.yLabel': 'Y축 레이블',
};
